// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CalendarModule } from 'primeng/calendar';
import { FormFieldModule } from '../form-field/form-field.module';
import { DateInputComponent } from './date-input.component';
// Afidium
import { DateComponent } from './date.component';

@NgModule({
    imports: [
        CalendarModule,
        FormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FontAwesomeModule,
        //TODO NG UPGRADE NgxErrorsModule,
    ],
    exports: [
        DateComponent,
        DateInputComponent
    ],
    declarations: [
        DateComponent,
        DateInputComponent
    ],
})
export class DateModule { }
